import React from 'react';
import { Route, Switch } from 'react-router';

// Layout & Route
import AdminLayoutRoute from './components/admin/adminLayoutRoute';
import FrontLayoutRoute from './components/front/frontLayoutRoute';
import PriviteLayoutRoute from './components/private/privateLayoutRoute';

// Private pages
import Login from './pages/private/login';
import Logout from './pages/private/logout';

// Admin Pages
import Admin from './pages/admin/home';
import Users from './pages/admin/users';
import UserCreate from './pages/admin/users/create';

import Boards from './pages/admin/boards';
import BoardCreate from './pages/admin/boards/create';
import BoardDetails from './pages/admin/boards/details';
import BoardUpdate from './pages/admin/boards/update';

import Books from './pages/admin/books';
//import BookCreate from './pages/admin/books/create';
//import BookDetails from './pages/admin/books/details';
//import BookUpdate from './pages/admin/books/update';


import Banners from './pages/admin/banners';
import BannerCreate from './pages/admin/banners/create';
import BannerUpdate from './pages/admin/banners/update';

// Front Pages
import Home from './pages/front/home';
import About from './pages/front/home/about';
import History from './pages/front/home/history';
import Field from './pages/front/home/field';
import Field2 from './pages/front/home/field2';

import Calendar from './pages/front/activity/calendar';
import Learn from './pages/front/activity/learn';
import Visit from './pages/front/activity/visit';

import Article from './pages/front/cinema/article';
import Guide from './pages/front/cinema/guide';
import Scene from './pages/front/cinema/scene';

import Intro from './pages/front/library/intro';
import Search2 from './pages/front/library/search';
import News from './pages/front/library/news';
//import Day from './pages/front/library/day';

import Newsletter from './pages/front/report/newsletter';
import Sniffleader from './pages/front/report/sniffleader';
import Resource from './pages/front/report/resource';

import Search from './pages/front/home/search';
import Details from './pages/front/board/details';


import Privacy from './pages/front/policy/privacy';
import Reject from './pages/front/policy/reject';

import Test from './pages/front/home/test';

// Redirect Pages
import IE from './pages/front/home/ie';

const App = props => {

    return (
        <Switch>
            {/* Privite */}
            <PriviteLayoutRoute path='/login' component={Login} />
            <PriviteLayoutRoute path='/logout' component={Logout} />

            {/* Admin */}
            <AdminLayoutRoute exact path='/admin' component={Admin} />

            {/* Admin User */}
            <AdminLayoutRoute path='/admin/users/create' component={UserCreate} />
            <AdminLayoutRoute path='/admin/users' component={Users} />

            {/* Admin Board */}
            <AdminLayoutRoute path='/admin/boards/create/:c/:s' component={BoardCreate} />
            <AdminLayoutRoute path='/admin/boards/details/:id' component={BoardDetails} />
            <AdminLayoutRoute path='/admin/boards/update/:id' component={BoardUpdate} />
            <AdminLayoutRoute exact path='/admin/boards/:c/:s' component={Boards} />

            {/* Admin Book */}
            {/*<AdminLayoutRoute path='/admin/books/create/:c/:s' component={BookCreate} />
            <AdminLayoutRoute path='/admin/books/details/:id' component={BookDetails} />
            <AdminLayoutRoute path='/admin/books/update/:id' component={BookUpdate} />*/}
            <AdminLayoutRoute exact path='/admin/books/:c/:s' component={Books} />

            {/* Admin Banner */}
            <AdminLayoutRoute path='/admin/banners/create/:c/:s' component={BannerCreate} />
            <AdminLayoutRoute path='/admin/banners/update/:id' component={BannerUpdate} />
            <AdminLayoutRoute exact path='/admin/banners/:c/:s' component={Banners} />

            {/* Ȩ/ī���� */}
            <FrontLayoutRoute exact path='/' component={Home} />
            <FrontLayoutRoute path='/home/about' component={About} />
            <FrontLayoutRoute path='/home/history' component={History} />
            <FrontLayoutRoute path='/home/field' component={Field} />
            <FrontLayoutRoute path='/home/field2' component={Field2} />
            {/*<FrontLayoutRoute path='/home/resource' component={Resource} />*/}
            <FrontLayoutRoute path='/home/search' component={Search} />

            {/* ����Ȱ�� */}
            <FrontLayoutRoute path='/activity/visit' component={Visit} />
            <FrontLayoutRoute path='/activity/visit/:p' component={Visit} />
            <FrontLayoutRoute path='/activity/learn' component={Learn} />
            <FrontLayoutRoute path='/activity/calendar' component={Calendar} />

            {/* ������ȭ�� */}
            <FrontLayoutRoute path='/cinema/guide' component={Guide} />
            <FrontLayoutRoute path='/cinema/article' component={Article} />
            <FrontLayoutRoute path='/cinema/scene' component={Scene} />

            {/* ůů������ */}
            <FrontLayoutRoute path='/library/intro' component={Intro} />
            <FrontLayoutRoute path='/library/search' component={Search2} />
            <FrontLayoutRoute path='/library/news' component={News} />
            {/*<FrontLayoutRoute path='/library/day' component={Day} />*/}

            {/* �ڷ�� */}
            <FrontLayoutRoute path='/report/newsletter' component={Newsletter} />
            <FrontLayoutRoute path='/report/sniffleader' component={Sniffleader} />
            <FrontLayoutRoute path='/report/resource' component={Resource} />

            {/* �Խ��� �󼼺��� */}
            <FrontLayoutRoute path='/details/:c/:s/:id' component={Details} />

            <FrontLayoutRoute path='/policy/privacy' component={Privacy} />
            <FrontLayoutRoute path='/policy/reject' component={Reject} />

            {/* Etc Page */}
            <FrontLayoutRoute path='/home/test' component={Test} />
            <Route path="/home/ie" component={IE} />

        </Switch>
    )
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js